import React, { useState, useEffect } from 'react'
import { useEditor, EditorContent } from '@tiptap/react'
import StarterKit from '@tiptap/starter-kit'
import Underline from '@tiptap/extension-underline'
import Strike from '@tiptap/extension-strike'
import Image from '@tiptap/extension-image'
import HardBreak from '@tiptap/extension-hard-break'
import Picker from '@emoji-mart/react'
import emojiData from '@emoji-mart/data'
import { CustomVideo } from './extensions/CustomVideo'
import Link from '@tiptap/extension-link'

import './styles/broadcast.css'
import { Mark } from '@tiptap/core'

const InlineQuote = Mark.create({
  name: 'inlineQuote',

  parseHTML() {
    return [{ tag: 'q' }]
  },

  renderHTML({ HTMLAttributes }) {
    return ['q', HTMLAttributes, 0]
  },
})
const API_UPLOAD = 'https://nts-center.ru/api/upload'          // ← your Flask /upload
const API_BROADCAST = 'https://nts-center.ru/api/broadcast' // ← your Flask /broadcast

export default function Broadcast() {
  const [showEmojiPicker, setShowEmojiPicker] = useState(false)
  const [buttonText, setButtonText] = useState("")
  const [buttonUrl, setButtonUrl] = useState("")
  const [focusedField, setFocusedField] = useState('editor') // 'editor' or 'button'

  const [drafts, setDrafts] = useState([])
  const [modalOpen, setModalOpen] = useState(false)
  const [currentDraft, setCurrentDraft] = useState(null)

  const [modalContent, setModalContent] = useState('')   // initial HTML for modal editor
  const [buttonType, setButtonType] = useState('url')  // or 'web_app'

  // modal editor (create only once; content updates via key)
  const modalEditor = useEditor({
    extensions: [StarterKit, Underline, Strike, Image, CustomVideo,                            // handles <img />
      Link.configure({
        openOnClick: false,
        autolink: false,
        protocols: ['http', 'https', 'mailto', 'tel'],
      }), HardBreak, InlineQuote],
    content: modalContent,
    autofocus: true,
    editorProps: { attributes: { class: 'modal-editor' } },
  }, [modalContent])   // refresh whenever modalContent changes

  /* ----- TIPTAP SETUP ----- */
  const editor = useEditor({
    extensions: [
      StarterKit,
      Underline,
      Strike,
      Image,
      CustomVideo,                                // handles <img />
      InlineQuote,
      Link.configure({
        openOnClick: false,
        autolink: false,
        protocols: ['http', 'https', 'mailto', 'tel'],
      }),
      HardBreak.configure({
        HTMLAttributes: {
          class: 'break',
        },
      }),
    ],
    content: '',
  })

  /* ----- INSERT EMOJI ----- */
  const insertEmoji = (emoji) => {
    const target = modalOpen ? modalEditor : editor

    if (focusedField === 'button') {
      setButtonText((prev) => prev + emoji.native)
    } else {
      target?.chain().focus().insertContent(emoji.native).run()
    }
  }

  const addLink = (targetEditor) => {
    const url = prompt('Введите URL (http…):')
    if (!url) return
    targetEditor
      ?.chain()
      .focus()
      .extendMarkRange('link')
      .setLink({ href: url })
      .run()
  }

  const toggleQuote = (ed) => {
    if (!ed) return;
    const { from, to } = ed.state.selection;
    if (from === to) {
      alert('Сначала выделите фрагмент текста для цитаты.');
      return;
    }

    ed.chain()
      .focus()                    // first restore focus (restores selection)
      .toggleMark('inlineQuote') // then apply mark
      .run();
  };
  /* ----- FILE UPLOAD (IMAGE / VIDEO) ----- */
  // const handleFileUpload = async (e) => {
  //   const file = e.target.files[0]
  //   if (!file) return

  //   const fd = new FormData()
  //   fd.append('file', file)

  //   try {
  //     const res = await fetch(API_UPLOAD, { method: 'POST', body: fd })
  //     const json = await res.json()
  //     console.log('📦 Upload response:', json)

  //     if (!json.success || !json.url) {
  //       alert('❌ Не удалось загрузить файл')
  //       return
  //     }

  //     const url = json.url
  //     const mime = file.type

  //     if (mime.startsWith('image/')) {
  //       editor
  //         ?.chain()
  //         .focus()
  //         .insertContent({ type: 'image', attrs: { src: url, alt: 'Uploaded' } })
  //         .run()
  //     } else if (mime.startsWith('video/')) {

  //       const videoNode = document.createElement("video")
  //       videoNode.setAttribute("controls", "")
  //       videoNode.style.maxWidth = "100%"

  //       const sourceNode = document.createElement("source")
  //       sourceNode.setAttribute("src", url)
  //       sourceNode.setAttribute("type", mime)

  //       videoNode.appendChild(sourceNode)
  //       editor
  //         ?.chain()
  //         .focus()
  //         .insertContent({
  //           type: 'customVideo',
  //           attrs: { src: url, type: mime },
  //         })
  //         .run()

  //     } else {
  //       alert('❌ Формат не поддерживается')
  //     }
  //   } catch (err) {
  //     console.error('Upload error:', err)
  //     alert('⚠️ Ошибка при загрузке файла.')
  //   }
  // }

  const handleFileUpload = async (e, targetEditor = editor) => {
    const file = e.target.files[0]
    if (!file) return

    const fd = new FormData()
    fd.append('file', file)

    try {
      const res = await fetch(API_UPLOAD, { method: 'POST', body: fd })
      const json = await res.json()

      if (!json.success || !json.url) {
        alert('❌ Не удалось загрузить файл')
        return
      }

      const url = json.url
      const mime = file.type

      if (mime.startsWith('image/')) {
        targetEditor
          ?.chain()
          .focus()
          .insertContent({ type: 'image', attrs: { src: url, alt: 'Uploaded' } })
          .run()
      } else if (mime.startsWith('video/')) {
        targetEditor
          ?.chain()
          .focus()
          .insertContent({
            type: 'customVideo',
            attrs: { src: url, type: mime },
          })
          .run()
      } else {
        alert('❌ Формат не поддерживается')
      }
    } catch (err) {
      console.error('Upload error:', err)
      alert('⚠️ Ошибка при загрузке файла.')
    }
  }


  const handleSaveDraft = async () => {
    const html = editor?.getHTML()
    if (!html) return

    const parser = new DOMParser()
    const doc = parser.parseFromString(html, 'text/html')

    const image = doc.querySelector('img')
    const video = doc.querySelector('video source')

    let mediaType = null
    let mediaUrl = null

    if (image) {
      mediaType = "image"
      mediaUrl = image.getAttribute("src")
      image.remove()
    } else if (video) {
      mediaType = "video"
      mediaUrl = video.getAttribute("src")
      video.parentElement?.remove()
    }

    const htmlFull = doc.body.innerHTML.trim()

    const draft = {
      media: mediaUrl || null,
      type: mediaType || null,
      caption: mediaUrl ? htmlFull : null,
      message: !mediaUrl ? htmlFull : null,
      button: buttonText && buttonUrl ? {
        text: buttonText.trim(),
        url: buttonUrl.trim(),
        type: buttonType
      } : null,
      created_at: new Date().toISOString()
    }

    await fetch('/api/save_broadcast_draft', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(draft)
    })

    alert('📥 Черновик сохранен!')
  }

  const refreshDrafts = async () => {
    const res = await fetch('/api/broadcast_drafts')
    const data = await res.json()
    setDrafts(data)
  }
  useEffect(() => {
    refreshDrafts()
  }, [])
  /* ----- SEND BROADCAST ----- */
  const handleSend = async () => {
    const html = editor?.getHTML()
    if (!html) return

    const parser = new DOMParser()
    const doc = parser.parseFromString(html, 'text/html')

    const image = doc.querySelector('img')
    const video = doc.querySelector('video source') // ✅ FIX: target <source>

    let mediaType = null
    let mediaUrl = null

    if (image) {
      mediaType = "image"
      mediaUrl = image.getAttribute("src")
      image.remove()
    } else if (video) {
      mediaType = "video"
      mediaUrl = video.getAttribute("src")
      video.parentElement?.remove() // remove <video> wrapper
    }

    const caption = doc.body.innerHTML.trim()

    const payload = mediaUrl
      ? { media: mediaUrl, caption, type: mediaType }
      : { message: caption }
    console.log("📦 Payload:", payload)

    if (buttonText && buttonUrl) {
      if (buttonType === 'web_app') {
        payload.button = {
          text: buttonText.trim(),
          web_app: { url: buttonUrl.trim() }
        }
      } else {
        payload.button = {
          text: buttonText.trim(),
          url: buttonUrl.trim()
        }
      }
    }
    try {
      const res = await fetch(API_BROADCAST, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      })

      const data = await res.json()
      if (data.success) {
        alert('📣 Сообщение отправлено!')
      } else {
        alert('❌ Ошибка при отправке.')
      }
    } catch (err) {
      console.error('❌ Broadcast error:', err)
      alert('⚠️ Ошибка подключения.')
    }
  }

  function openDraft(d) {
    setCurrentDraft(d)
    setButtonText(d.button?.text || "")
    setButtonUrl(d.button?.url || "")
    // Build HTML for the modal

    let html = d.caption || d.message || ""
    if (d.type === "image") {
      html = `<img src="${d.media}" /><br>` + html
    } else if (d.type === "video") {
      html = `<video controls><source src="${d.media}"/></video><br>` + html
    }
    setModalContent(html)      // modalEditor will reload
    setModalOpen(true)
    setButtonType(d.button?.type || 'url')
  }

  async function saveDraftChanges() {
    const html = modalEditor?.getHTML()
    if (!html) return             // safety

    const changes = buildPayloadFromHTML(html) // helper below
    await fetch(`/api/broadcast_draft/${currentDraft._id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(changes),
    })
    refreshDrafts()
    setModalOpen(false)
  }

  const focusCurrentEditor = (ed) => {
    if (!ed) return;
    setFocusedField('editor');      // so emoji/quote know who is active
    // ed.commands.focus('end');       // move caret to end (or simply .focus() )
  };

  const buildPayloadFromHTML = (html) => {
    const doc = new DOMParser().parseFromString(html, 'text/html')

    const image = doc.querySelector('img')
    const video = doc.querySelector('video source')

    let type = null, media = null
    if (image) { type = 'image'; media = image.src; image.remove() }
    if (video) { type = 'video'; media = video.src; video.parentElement?.remove() }

    const htmlFull = doc.body.innerHTML.trim()

    return {
      media,
      type,
      caption: media ? htmlFull : null,
      message: !media ? htmlFull : null,
      button: buttonText && buttonUrl ? {
        text: buttonText.trim(),
        url: buttonUrl.trim(),
        type: buttonType
      } : null,
      updated_at: new Date().toISOString()
    }
  }

  async function deleteDraft() {
    await fetch(`/api/broadcast_draft/${currentDraft._id}`, { method: 'DELETE' })
    refreshDrafts()
    setModalOpen(false)
  }

  async function sendDraft() {
    await fetch('/api/broadcast', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ ...currentDraft, action: "send" })
    })
    alert('📣 Отправлено')
  }



  /* ----- UI ----- */
  return (
    <>
      <div className="broadcast-page">
        <div className="editor-wrapper">
          {/* Toolbar */}
          <div className="toolbar">
            <button onClick={() => editor?.chain().focus().toggleBold().run()}><b>B</b></button>
            <button onClick={() => editor?.chain().focus().toggleItalic().run()}><i>I</i></button>
            <button onClick={() => editor?.chain().focus().toggleUnderline().run()}><u>U</u></button>
            <button onClick={() => editor?.chain().focus().toggleStrike().run()}><s>S</s></button>
            <button onClick={() => {
              setFocusedField('editor')
              setShowEmojiPicker(!showEmojiPicker)
            }}>😊</button>

            <button
              className={editor?.isActive('inlineQuote') ? 'active' : ''}
              onClick={() => toggleQuote(editor)}
            >❝</button>
            <button onClick={() => addLink(editor)}>🔗</button>
            <label className="upload-label">📎
              <input
                type="file"
                accept="image/*,video/*"
                onChange={handleFileUpload}
                hidden
              />
            </label>
          </div>

          {/* Emoji picker */}
          {showEmojiPicker && (
            <div className="emoji-picker">
              <Picker data={emojiData} onEmojiSelect={insertEmoji} theme="light" />
            </div>
          )}

          {/* Editor */}
          {/* <EditorContent editor={editor} className="editor-content" /> */}
          <EditorContent
            editor={editor}
            className="editor-content"
            onClick={() => focusCurrentEditor(editor)}
          />
          <input
            type="text"
            placeholder="🔗 Button Text (with emoji)"
            value={buttonText}
            onFocus={() => setFocusedField('button')}
            onChange={(e) => setButtonText(e.target.value)}
          />
          <input type="url" placeholder="Button URL" value={buttonUrl} onChange={(e) => setButtonUrl(e.target.value)} />
          <div className="button-type-selector">
            <label>
              <input
                type="radio"
                name="buttonType"
                value="url"
                checked={buttonType === 'url'}
                onChange={() => setButtonType('url')}
              />
              🌐 Сайт
            </label>
            <label>
              <input
                type="radio"
                name="buttonType"
                value="web_app"
                checked={buttonType === 'web_app'}
                onChange={() => setButtonType('web_app')}
              />
              📲 Вебап
            </label>
          </div>
          <button className="send-button" onClick={handleSend}>
            Отправить
          </button>
          <button className="send-button" onClick={handleSaveDraft}>
            💾 Сохранить в базу
          </button>
        </div>
      </div>

      <div className="draft-list">
        {drafts.map(d => (
          <div key={d._id} className="draft-card" onClick={() => openDraft(d)}>
            {d.type && <span className="tag">{d.type}</span>}
            <p
              dangerouslySetInnerHTML={{
                __html: (d.caption || d.message || "").slice(0, 80),
              }}
            />
            {d.button && <small>🔗 {d.button.text}</small>}
          </div>
        ))}
      </div>
      {modalOpen && (
        <div className="modal-backdrop">
          <div className="modal">
            <h3>Редактирование</h3>
            <div className="toolbar">
              <button onClick={() => modalEditor?.chain().focus().toggleBold().run()}><b>B</b></button>
              <button onClick={() => modalEditor?.chain().focus().toggleItalic().run()}><i>I</i></button>
              <button onClick={() => modalEditor?.chain().focus().toggleUnderline().run()}><u>U</u></button>
              <button onClick={() => modalEditor?.chain().focus().toggleStrike().run()}><s>S</s></button>
              <button onClick={() => {
                setFocusedField('editor')
                setShowEmojiPicker(!showEmojiPicker)
              }}>😊</button>

              <button
                className={modalEditor?.isActive('inlineQuote') ? 'active' : ''}
                onClick={() => toggleQuote(modalEditor)}
              >❝</button>
              <button onClick={() => addLink(modalEditor)}>🔗</button>
              <label className="upload-label">📎
                <input
                  type="file"
                  accept="image/*,video/*"
                  onChange={(e) => handleFileUpload(e, modalEditor)} // Pass modalEditor as target
                  hidden
                />
              </label>
            </div>
            {showEmojiPicker && focusedField === 'editor' && modalOpen && (
              <div className="emoji-picker">
                <Picker data={emojiData} onEmojiSelect={insertEmoji} theme="light" />
              </div>
            )}
            {/* <EditorContent editor={modalEditor} className="modal-editor" /> */}
            <EditorContent
              editor={modalEditor}
              className="modal-editor"
              onClick={() => focusCurrentEditor(modalEditor)}
            />

            <input
              type="text"
              placeholder="🔗 Button text"
              value={buttonText}
              onFocus={() => setFocusedField('button')}
              onChange={e => setButtonText(e.target.value)}
            />
            <input
              type="url"
              placeholder="Button URL"
              value={buttonUrl}
              onChange={e => setButtonUrl(e.target.value)}
            />

            <div className="button-type-selector">
              <label>
                <input
                  type="radio"
                  name="modalButtonType"
                  value="url"
                  checked={buttonType === 'url'}
                  onChange={() => setButtonType('url')}
                />
                🌐 Сайт
              </label>
              <label>
                <input
                  type="radio"
                  name="modalButtonType"
                  value="web_app"
                  checked={buttonType === 'web_app'}
                  onChange={() => setButtonType('web_app')}
                />
                📲 Вебап
              </label>
            </div>

            <div className="modal-actions">
              <button onClick={saveDraftChanges}>💾 Сохранить</button>
              <button onClick={sendDraft}>📣 Отправить</button>
              <button onClick={deleteDraft}>🗑 Удалить</button>
              <button onClick={() => setModalOpen(false)}>✖ Закрыть</button>
            </div>
          </div>
        </div>
      )}
    </>
  )
}
